import { Language } from '@/services/graphQL/api/generated/types_web';

// Device locales the app UI can render. A new language also needs the matching
// Language enum member, a public/locales/<key>.json, and the switches in
// utils/getTime, utils/isDateTimeInRange and ScreenSaver's langKey.
const SUPPORTED_LANGUAGES: Record<string, Language> = {
  en: Language.En,
  fr: Language.Fr,
};

/**
 * Maps a language tag (e.g. 'fr-CA', 'FR', 'fr') to a supported Language,
 * defaulting to English for anything unsupported, empty or missing.
 *
 * Use this at every boundary where a language enters the app — device locales
 * and the profile API's `uiLanguage`, which arrives unnormalized.
 */
export const normalizeDeviceLanguage = (locale?: string | null): Language => {
  if (typeof locale !== 'string' || !locale) return Language.En;
  const base = locale.split('-')[0].toLowerCase();
  return SUPPORTED_LANGUAGES[base] ?? Language.En;
};
